$(function() {
    var isAnimating = false;
    const subNavIsSubpages = document.querySelector('.tabs.tabs--subpages') !== null;

    // Calculate offset based on hero height and any admin bars
    function getOffset() {
        var hero = document.getElementById('landing-hero');
        var ctaBar = document.querySelector('.cta-bar');
        var ctaHeight = ctaBar ? ctaBar.offsetHeight : 50;
        var heroHeight = hero ? hero.offsetHeight : 0;

        // Check for admin/debug bars - add their height to maintain consistent scroll position
        var adminBar = document.querySelector('.admin-bar, #admin-bar');
        var debugBar = document.querySelector('.debug-bar');
        var adminBarHeight = adminBar ? adminBar.offsetHeight : 0;
        var debugBarHeight = debugBar ? debugBar.offsetHeight : 0;
        var totalBarHeight = adminBarHeight + debugBarHeight;

        // Smaller heroes need less offset, larger heroes need more
        var basePadding = 100;
        var heroAdjustment = (heroHeight - 500) * 0.25;
        var offset = ctaHeight + basePadding + heroAdjustment + totalBarHeight;

        return Math.round(offset);
    }

    $(document).on('scroll', function() {
        if (subNavIsSubpages) {
            return;
        }

        // Don't update tabs while animating to a clicked section
        if (isAnimating) {
            return;
        }

        var offset = window.pageYOffset;
        var idToChange;
        var closestDistance = Infinity;
        var scrollOffset = getOffset() + 10; // Add small buffer to trigger tab change slightly earlier

        $('.anchor__scroll').each(function(key, value) {
            item = $(value);
            var itemId = item.attr('id');

            // Skip sections without a valid ID
            if (!itemId) {
                return;
            }

            var itemTop = item.offset().top - scrollOffset;
            if (itemTop <= offset) {
                // Find the section closest to (but still above) current scroll position
                var distance = offset - itemTop;
                if (distance < closestDistance) {
                    closestDistance = distance;
                    idToChange = itemId;
                }
            }
        });

        if (!!idToChange) {
            $('.tabs__tab--active').removeClass('tabs__tab--active');
            $('.tabs__tab--collection[href="#' + idToChange + '"]').addClass('tabs__tab--active');

            var tab = $('.tabs__tab--collection[href="#' + idToChange + '"]');

            if (!!tab && typeof tab.position() != 'undefined') {
                var scrollLeft = tab.position().left;
                $('.cta-bar__scroller').scrollLeft(scrollLeft);
            }
        }
    });

    $('.tabs__tab--collection').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        // Block scroll handler during animation
        isAnimating = true;

        var scrollLeft = $(this).position().left;
        $('.cta-bar__scroller').scrollLeft(scrollLeft);

        var $this = $(this),
            $target;
        if (!!$this.data('target')) {
            $target = $('#'+$this.data('target'));
        } else if (!!$this.attr('href') && "#" == $this.attr('href').replace(window.location.pathname,"")[0]) {
            $target = $($this.attr('href').replace(window.location.pathname,""));
        }
        if ($target.length) {
            var offset = getOffset();
            var targetId = $target.attr('id');

            // Temporarily remove ID to prevent browser jump
            $target.attr('id', '');

            $("html,body").stop().animate({
                scrollTop: $target.offset().top - offset
            }, 800, 'swing', function() {
                // Restore ID after animation
                $target.attr('id', targetId);

                // Re-enable scroll handler and trigger check
                setTimeout(function() {
                    isAnimating = false;
                    $(document).trigger('scroll');
                }, 50);
            });
        }

        return false;
    });
});
